import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';



import { AvatarService } from './api/avatar.service';
import { ClienteService } from './api/cliente.service';
import { ConsolidadoService } from './api/consolidado.service';
import { ContactoService } from './api/contacto.service';
import { CuentaService } from './api/cuenta.service';
import { DepositoService } from './api/deposito.service';
import { LogsService } from './api/logs.service';
import { MenuService } from './api/menu.service';
import { OtpService } from './api/otp.service';
import { PagoFacilitoService } from './api/pagoFacilito.service';
import { PagoServicioService } from './api/pagoServicio.service';
import { ParametrizacionService } from './api/parametrizacion.service';
import { PreguntaService } from './api/pregunta.service';
import { PrestamoService } from './api/prestamo.service';

import { RegistroService } from './api/registro.service';
import { RolService } from './api/rol.service';
import { TipoIdentificacionService } from './api/tipoIdentificacion.service';
import { TransferenciaService } from './api/transferencia.service';
import { UsuarioService } from './api/usuario.service';
import { RecuperacionService } from './api/recuperacion.service';
import { AccesoService } from './api/acceso.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    AccesoService,
    AvatarService,
    ClienteService,
    ConsolidadoService,
    ContactoService,
    CuentaService,
    DepositoService,
    LogsService,
    MenuService,
    OtpService,
    PagoFacilitoService,
    PagoServicioService,
    ParametrizacionService,
    PreguntaService,
    PrestamoService,
    RecuperacionService,
    RegistroService,
    RolService,
    TipoIdentificacionService,
    TransferenciaService,
    UsuarioService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
